import {useGlp1Modality} from 'surveys/osa_funnel/hooks/useGlp1Modality';
import {Glp1EducationOutcomeBranded} from './Glp1EducationOutcomeBranded';
import {Glp1EducationOutcomeCompounded} from './Glp1EducationOutcomeCompounded';

export const Glp1EducationOutcome = () => {
  const modality = useGlp1Modality();
  return modality === 'compounded_v1' ? <Glp1EducationOutcomeCompounded /> : <Glp1EducationOutcomeBranded />;
};

export default Glp1EducationOutcome;
